<template>
    <!-- Componente para mostrar el iframe del formulario de cita de servicio -->
    <div class="mt-6">
        <div v-if="showIframe">
            <iframe
                v-if="appEnv !== 'production'"
                :src="'https://test.hyundaimotormex-leads.com/f2/servicio_cn_sf/?dealer_code=' + subsidiary.caption_text"
                width="100%"
                scrolling="no"
                style="border: 0"
            ></iframe>
            <iframe
                v-else
                :src="'https://hyundaimotormex-leads.com/f2/servicio_cn_sf/?dealer_code=' + subsidiary.caption_text"
                width="100%"
                scrolling="no"
                style="border: 0"
            ></iframe>
        </div>
        <div
            v-else
            class="text-center lg:text-left w-64 lg:w-full mx-auto mb-6 lg:pl-4"
        >
            <p class="text-base sm:text-lg">Tu solicitud de cita de servicio aun no queda completada. Un ejecutivo te contactará para confirmar disponibilidad.</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['subsidiary', 'appEnv'],
    data() {
        return {
            showIframe: true,
        }
    },
    mounted() {
        iFrameResize({
            log: false,                  // Enable console logging
            enablePublicMethods: true,                  // Enable methods within iframe hosted page
        });

        // addEventListener support for IE8
        function bindEvent(element, eventName, eventHandler) {
            if (element.addEventListener) {
                element.addEventListener(eventName, eventHandler, false);
            } else if (element.attachEvent) {
                element.attachEvent('on' + eventName, eventHandler);
            }
        }

        // Listen to message from child window
        bindEvent(window, 'message', (e) => {
            if (e.data.id != undefined) {
                // console.log(e.data);
                dataLayer.push({
                    'event': 'cita_servicio',
                    'id_cita_servicio': e.data.id,
                    'modelo': e.data.modelo,
                    'tipo_servicio': e.data.tipo_servicio,
                    'kilometros_meses': e.data.kilometrosMeses,
                    'distribuidor': this.subsidiary.name,
                    'cp': this.subsidiary.zip_code
                });
                // console.log(dataLayer);
                this.$eventBus.$emit('iframe-appointment-message', {
                    'modelo': e.data.modelo,
                    'kilometrosMeses': e.data.kilometrosMeses
                })
                this.showIframe = false
            }
        });
    }
}
</script>

<style>

</style>
